import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-addvoucher',
  templateUrl: './addvoucher.component.html',
  styleUrls: ['./addvoucher.component.css']
})
export class AddvoucherComponent implements OnInit  {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  voucherColl: any = [];


  //pageColl:any=[];

  voucherform = new FormGroup({
    voucherid: new FormControl(0),
    voucherno: new FormControl('', Validators.required),
    voucherdate: new FormControl(null, Validators.required),
    expdate: new FormControl(null, Validators.required),
    voucheramt: new FormControl(null, Validators.required),
    description: new FormControl(''),
    refno: new FormControl(''),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Voucher";

  @Input() voucherid: number = 0
  @Input() voucherdate: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute, private datePipe: DatePipe,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.voucherid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.voucherform.reset();
      this.fnInitializeVoucher();

      if (this.voucherid > 0) {
        this.fngetVoucher();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.voucherid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeVoucher() {
    this.voucherform.setValue({

      voucherid: 0,
      voucherno: '',
      voucherdate: new Date(),
      expdate: new Date(),
      voucheramt: null,
      description: '',
      refno: '',
      inactive: false,
    })
  }

  //Get 
  fngetVoucher() {

    var data = {
      'voucherid': this.voucherid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getVoucher(data)
      .subscribe(
        (res) => {
          this.voucherColl = res.json().result;
          var editdata = this.voucherColl[0];
          //console.log(editdata)
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if(this.saveloading){
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.voucherform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'voucherid': this.voucherid,
          'voucherno': this.voucherform.get('voucherno').value,
          'voucherdate': this.fnFormatDatetime(this.voucherform.get('voucherdate').value),
          'expdate': this.fnFormatDatetime(this.voucherform.get('expdate').value),
          'voucheramt': this.voucherform.get('voucheramt').value,
          'description': this.voucherform.get('description').value,
          'refno': this.voucherform.get('refno').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.voucherform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
        this.appService.fnCheckVoucher(data).subscribe(
          (res) => {
         
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.voucherform.get('voucherid').value > 0) {
                //Update Department
                this.fnSetVoucher(data);
              }
              else {
                //Insert Department
                this.fnInsertVoucher(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false

                this.voucherform.controls['voucherno'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false

      this.fnShowErrorMsg(ex);
    }
  }


//Insert
fnInsertVoucher(data) {

  this.appService.fnInsertVoucher(data).subscribe(
    (res) => {
      this.saveloading=false

      if (res.json().status === 200) {

        var result = res.json().result;

        var rtnvoucherid = 0;
        if (result.length > 0) {
          rtnvoucherid = result[0].voucherid

        }
        this.toastr.success('', "The new Voucher has been added successfully.Insert Successfully");

        this.fnInsertActivityLog('INSERT', 0, data.voucherid);

        this.emitData.emit(rtnvoucherid);
        this.activeModal.close(true);
      }
    },
    (err) => {
      this.saveloading=false

      this.toastr.error('Error', err);
    });

}

//Set
fnSetVoucher(data) {

  this.appService.fnSetVoucher(data).subscribe(
    (res) => {
      this.saveloading=false

      if (res.json().result != "") {
        this.toastr.success('', "The voucher has been updated successfully.");

        this.fnInsertActivityLog('EDIT', this.voucherid, data.voucherdate);

        this.emitData.emit(this.voucherid);
        this.activeModal.close(true);
      }
    },
    (err) => {
      this.saveloading=false
      this.toastr.error('Error', err);
    });

}



  private fnEditMode(deptBO) {
    deptBO.voucherdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.voucherdate));
    deptBO.expdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.expdate));
  this.voucherform.setValue({

    voucherid: deptBO.voucherid,
    voucherno: deptBO.voucherno,
    voucherdate: deptBO.voucherdate,
    expdate: deptBO.expdate,
    voucheramt: deptBO.voucheramt,
    description: deptBO.description,
    refno: deptBO.refno,
    inactive: deptBO.inactive,
  });

  this.isaddmode = false;
  this.iseditmode = true;
  this.isdeletemode = false;
  this.isviewmode = false;
}



fnInsertActivityLog(action, refno, desc) {
  try {
    var data = {
      logtype: action,
      logat: this.formname,
      refnum: refno,
      logdescr: desc,
      logby: this.loginService.fnGetModUserId(),
      'companyid': this.loginService.fnGetCompanyId(),

    }


     this.appService.fnInsertActivity(data).subscribe(
       (res)=>{
       },
       (err)=>{

       });

  } catch {

  }
}
fnFormatDatetime(dt) {
  if (dt) {
    if (dt === "") {
      return null
    }
    else {
      return this.datePipe.transform(dt, "yyyy-MM-dd")
    }

  } else {
    return null
  }

}
fnConvertDatetime(dt) {
  if (dt) {
    if (dt === "") {
      return null
    }
    else {
      var dateParts = dt.split("-");
      var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
      sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
      return sdate;
    }

  } else {
    return null
  }

}



  public decline() {
  this.activeModal.close(false);
}



  private fnShowErrorMsg(ex) {
  this.toastr.warning('Internal Error', ex);
}





}
